exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir=ltr] .azTFuaTl1ZzKn7j5ne5xN{margin-left:2px}html[dir=rtl] .azTFuaTl1ZzKn7j5ne5xN{margin-right:2px}._14FlkcrEI81Im_gUQ_0Sd_{font-weight:600}html[dir=ltr] ._14FlkcrEI81Im_gUQ_0Sd_{padding-right:3px}html[dir=rtl] ._14FlkcrEI81Im_gUQ_0Sd_{padding-left:3px}._2gIHyl6dQwPnFYZasfY8zh{display:inline}", ""]);

// exports
exports.locals = {
	"wellTrailingComponent": "azTFuaTl1ZzKn7j5ne5xN",
	"label": "_14FlkcrEI81Im_gUQ_0Sd_",
	"divFixer": "_2gIHyl6dQwPnFYZasfY8zh"
};